import { BaseModel } from "./BaseModel";

export class Blocklist extends BaseModel {
  schema = "/blocklist";
  constructor(params) {
    return super(params, "/blocklist");
  }
}
